module.exports = __webpack_public_path__ + "img/返回.b94bbed5.svg";